export enum OrderTimeLineStatus {
    None = 'None',
    Undefined = 'Undefined',
    Received = 'Received',
    Preparing = 'Preparing',
    Delivering = 'Delivering',
    Completed = 'Completed',
}